import { render, staticRenderFns } from "./StatisticsBranch.vue?vue&type=template&id=46c1bdcc&scoped=true"
import script from "./StatisticsBranch.vue?vue&type=script&lang=js"
export * from "./StatisticsBranch.vue?vue&type=script&lang=js"
import style0 from "./StatisticsBranch.vue?vue&type=style&index=0&id=46c1bdcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c1bdcc",
  null
  
)

export default component.exports